import { IconButton } from '@chakra-ui/react';
import { type RefObject, useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

export const ScrollToTopButton = ({ scrollContainerRef }: { scrollContainerRef: RefObject<HTMLElement | null> }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setIsVisible(container.scrollTop > 300);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [scrollContainerRef]);

  const scrollToTop = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <IconButton aria-label="Scroll top" rounded="full" onClick={scrollToTop} position="fixed" bottom="6" right="6">
          <FaArrowUp />
        </IconButton>
      )}
    </>
  );
};

export default ScrollToTopButton;
